// extracted by mini-css-extract-plugin
module.exports = {"arrows":"Pagination_arrows__3eZ1K","arrows__left":"Pagination_arrows__left__wZYMm","arrows__right":"Pagination_arrows__right__3kPHL","pages":"Pagination_pages__3cl-k"};